import { z } from "zod";

import { fetchWithError, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

export const taskSchema = z.object({
  uuid: z.string(),
  url: z.string(),
  status: z.string() /* Actually an enum */,
  result: z.string().nullable() /* E.g. download link */,
  detail: z.string().nullable() /* Error message, I think? */,
});

export type Task = z.infer<typeof taskSchema>;
export type TaskList = Task[];

/* Note that the /tasks/ endpoint has no "normal" list; it always needs
   a uuid__in= parameter. Which means we can directly use it for useMultiple,
   but nothing else. */

export function useTask(uuid: string) {
  return useParsedQuery<Task>(
    ["lizard-api-v4", "tasks", uuid],
    () => fetchWithError(`/api/v4/tasks/${uuid}/`),
    (json: unknown) => taskSchema.parse(json)
  );
}

export function useMultipleTasks(uuids: string[]) {
  const url = combineUrlAndParams(`/api/v4/tasks/`, { uuid__in: uuids.join(",") });
  return useParsedQuery<TaskList>(
    ["lizard-api-v4", "tasks", url],
    () => fetchWithError(url),
    (json: unknown) => z.array(taskSchema).parse(json)
  );
}
